import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import { PATH } from '../../../constants/path';
import { PATH_TO_PARTNER } from '../../../services/i18n/constants';
import { APPLICATION_ID, HAS_INSTANT_DISCOUNT } from '../../../constants';
import { STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED } from '../../../constants/storage';

import {
    fetcheBonsByPartnerId,
    fetcheFAQByPartnerId,
    resetLock,
    resetOrder
} from '../../../services/ebon/actions';
import {
    fetchPartnerDiscountsIfNeeded,
    forceFetchDiscounts
} from '../../../services/discount/actions';

import {
    getPartner,
    getOfflinePartnerByMoId,
    getEbonPartner
} from '../../../services/partner/selector';
import { getI18nByApp, getI18nByKey, getRefundWording } from '../../../services/i18n/selector';

import {
    getPartnerIdFromQuery,
    getPartnerNameFromQuery,
    isNormalInteger,
    scrollToAnchor
} from '../../../utils/index';
import { isFailureBankTransferEnabled } from '../../../utils/plebicardUtils';
import { displayableCashbackComplete } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams, removeListMarker } from '../../../utils/htmlUtils';

import HeaderComponent from './HeaderComponent';
import HeadComponent from '../../HeadComponent';
import StepEbonComponent from './StepEbonComponent';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import DiscountsListComponent from './DiscountsListComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import EbonSelectorComponent from './ebonselector/EbonSelectorComponent';
import { withLoadingCondition } from '../../loading/withLoadingCondition';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import { FaqContainer, HelpContainer, MerchantCardPageContainer } from './MerchantCardPageStyle';

export class MerchantCardPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partnerId: -1,
            partnerName: ''
        };
    }

    componentWillMount() {
        this.initPage(
            getPartnerIdFromQuery(this.props.match.params.query),
            getPartnerNameFromQuery(this.props.match.params.query)
        );
    }

    componentDidMount() {
        const { resetLock, resetOrder } = this.props;

        scrollToAnchor(this.props.location);

        resetLock();
        resetOrder();
    }

    componentDidUpdate(prevProps) {
        const {
            partner,
            ebonPartner,
            history,
            fetching,
            ebonPartnerFetching,
            isEbon,
            ebons
        } = this.props;

        if (
            (!isEbon && !fetching && !partner) ||
            (isEbon && !ebonPartnerFetching && !ebonPartner)
        ) {
            history.push(PATH.NOT_FOUND_PATH);
        }

        if (!isFailureBankTransferEnabled() && isEbon && ebons && ebons.ebonPaymentConfig) {
            sessionStorage.setItem(
                STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED,
                ebons.ebonPaymentConfig.failureBankTransferEnabled
            );
        }
    }

    componentWillReceiveProps = nextProps => {
        const { history, isAuthenticated, forceFetchDiscounts } = this.props;
        const { partnerId, partnerName } = this.state;
        const partnerIdUrl = getPartnerIdFromQuery(nextProps.match.params.query);
        const partnerNameUrl = getPartnerNameFromQuery(nextProps.match.params.query);

        if (!isNormalInteger(partnerIdUrl)) {
            history.push('/404');
        } else if (partnerId !== partnerIdUrl && partnerName !== partnerNameUrl) {
            this.initPage(partnerIdUrl, partnerNameUrl);
        }

        if (isAuthenticated !== nextProps.isAuthenticated) {
            forceFetchDiscounts(partnerId);
        }
    };

    initPage(partnerId, partnerName) {
        const {
            fetchPartnerDiscountsIfNeeded,
            fetcheBonsByPartnerId,
            fetcheFAQByPartnerId
        } = this.props;
        this.setState({ partnerId, partnerName });
        fetchPartnerDiscountsIfNeeded(partnerId);
        fetcheBonsByPartnerId(partnerId);
        fetcheFAQByPartnerId(partnerId);
    }

    renderPage = () => {
        const {
            i18n,
            i18nPage,
            i18nCustomerService,
            i18nPageHowItWorks,
            partner,
            CASHBACK,
            partnerDisplayableCashbackComplete,
            match,
            ebonPartner,
            ebons,
            faqEbon
        } = this.props;

        const { parameters } = ebons;
        const isOffline = match && match.params.type === PATH.OFFLINE;
        const isEbon = match && match.params.type === PATH.EBON;

        const currentPartner = isEbon ? ebonPartner : partner;

        let savFaq = faqEbon ? faqEbon[3] : null;
        savFaq
            ? (savFaq.content = getI18nByApp(i18n, 'page.MERCHANTCARD.SAV_EBON_FAQ'))
            : (savFaq = null);
        const finalFaqEbon = savFaq
            ? [...faqEbon.filter(faq => faq.number !== 4), savFaq]
            : faqEbon;

        return (
            <div className="flex-container-v">
                <MerchantCardPageContainer className="conteneur conteneur-mobile">
                    <HeadComponent
                        title={format(
                            getI18nByApp(i18n, 'page.MERCHANTCARD.TITLE'),
                            currentPartner.name,
                            partnerDisplayableCashbackComplete
                        )}
                        description={i18nPage.DESCRIPTION}
                    />
                    <LocalizedBreadcrumbItem to={`${PATH.CASHBACK_PATH}/${match.params.type}`}>
                        {isOffline
                            ? i18nPage.OFFLINE_BREADCRUMB
                            : isEbon
                            ? getI18nByApp(i18n, 'page.MERCHANTCARD.EBON_BREADCRUMB')
                            : i18nPage.ONLINE_BREADCRUMB}
                    </LocalizedBreadcrumbItem>
                    <LocalizedBreadcrumbItem
                        to={`${PATH.MERCHANTPAGE_PATH}${match.params.type}/${this.state.partnerId}-${this.state.partnerName}`}>
                        {currentPartner.name}
                    </LocalizedBreadcrumbItem>
                    {HAS_INSTANT_DISCOUNT ? (
                        <h1>{`${getI18nByApp(i18n, 'common.EBON')} ${currentPartner.name}`}</h1>
                    ) : (
                        <h1>{`${CASHBACK} ${
                            isEbon ? getI18nByApp(i18n, 'page.MERCHANTCARD.EBON_TYPE') : ''
                        } ${currentPartner.name}`}</h1>
                    )}

                    <HeaderComponent
                        id={this.state.partnerId}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />

                    {isEbon && ebons && ebons.ebonDiscount && (
                        <EbonSelectorComponent partner={currentPartner} />
                    )}

                    {!isEbon && (
                        <DiscountsListComponent
                            partnerId={this.state.partnerId}
                            isOffline={isOffline}
                        />
                    )}

                    <div id="conditions" />
                    {isEbon && faqEbon.length > 0 && faqEbon.filter(f => f.conditions).length > 0 && (
                        <section>
                            <h3>{i18nPage.CONDITIONS_TITLE}</h3>
                            <div>
                                {faqEbon
                                    .filter(f => f.conditions)
                                    .map(f =>
                                        convertHtmlToReactDomWithParams(removeListMarker(f.content))
                                    )}
                            </div>
                        </section>
                    )}

                    {isEbon && parameters && (
                        <React.Fragment>
                            <section>
                                <h3>
                                    {convertHtmlToReactDomWithParams(
                                        getI18nByApp(i18n, 'page.MERCHANTCARD.WHERE_AND_HOW_TITLE'),
                                        currentPartner.name
                                    )}
                                </h3>
                                <StepEbonComponent
                                    partner={currentPartner}
                                    parameters={parameters}
                                />
                            </section>
                        </React.Fragment>
                    )}
                </MerchantCardPageContainer>

                {isEbon && (
                    <React.Fragment>
                        <HelpContainer className="conteneur grid">
                            <FaqContainer className="inbl">
                                <div className="faq-bandeau">{i18nPageHowItWorks.QUESTION}</div>
                                <div className="faq-list-container">
                                    {finalFaqEbon.length > 0 &&
                                        finalFaqEbon.map(faq => (
                                            <FaqElementComponent
                                                key={faq.id}
                                                faq={faq}
                                                cssClass="question-comment-ca-marche-page"
                                                noListMarker
                                                isEbonFaq
                                            />
                                        ))}
                                </div>
                            </FaqContainer>
                            <CustomerServiceComponent
                                i18n={i18nCustomerService}
                                cssClass="merchantCard"
                            />
                        </HelpContainer>
                    </React.Fragment>
                )}

                <HowItWorksComponent
                    topShadow
                    showTitle
                    isOffline={isOffline}
                    isEbon={isEbon}
                    cssClass="conteneur conteneur-mobile"
                />
            </div>
        );
    };

    render() {
        const {
            fetching = false,
            partner = null,
            ebonPartnerFetching = false,
            ebonPartner = null,
            isEbon
        } = this.props;
        const mustLoad =
            (!isEbon && (fetching || !partner)) ||
            (isEbon && (ebonPartnerFetching || !ebonPartner));

        return withLoadingCondition(mustLoad, this.renderPage);
    }
}

MerchantCardPage.propTypes = {
    i18nPage: PropTypes.object.isRequired,
    coupons: PropTypes.array,
    discounts: PropTypes.array,
    partner: PropTypes.object,
    match: PropTypes.object.isRequired,
    partnerDisplayableCashbackComplete: PropTypes.string,
    user: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    const isOffline = ownProps.match && ownProps.match.params.type === PATH.OFFLINE;
    const isEbon = ownProps.match && ownProps.match.params.type === PATH.EBON;

    const partnerId = getPartnerIdFromQuery(ownProps.match.params.query);
    const partner = getPartner(state, partnerId);
    const ebonPartner = getEbonPartner(state, Number(partnerId));

    const cashbackWordings = state.i18n.common.CASHBACK;
    const cashback = cashbackWordings[APPLICATION_ID]
        ? cashbackWordings[APPLICATION_ID]
        : cashbackWordings.DEFAULT;

    return {
        CASHBACK: cashback,
        i18n: state.i18n,
        i18nPage: state.i18n.page.MERCHANTCARD,
        i18nPageHowItWorks: state.i18n.page.HOW_IT_WORKS,
        i18nCustomerService: state.i18n.feature.aide.serviceclient,
        isAuthenticated: state.authentication.isAuthenticated,
        user: toPlainObject(state.account.user),
        partner,
        isEbon,
        ebons: state.ebon.ebons,
        ebonPartner,
        ebonPartners: state.ebon.ebonPartners,
        offlinePartner: getOfflinePartnerByMoId(state, partner && partner.moId),
        partnerDisplayableCashbackComplete: displayableCashbackComplete(
            isEbon ? ebonPartner : partner,
            getI18nByKey(state, PATH_TO_PARTNER),
            isOffline,
            isEbon,
            getRefundWording(state, APPLICATION_ID)
        ),
        fetching: state.partner.fetching,
        ebonPartnerFetching: state.ebon.ebonPartnersFetching,
        shops: state.shop.shops[partnerId] ? state.shop.shops[partnerId] : null,
        shopStatus: state.shop.fetching,
        shopError: state.shop.error,
        isOffline: isOffline,
        faqEbon: state.ebon.faq || []
    };
};

const mapDispatchToProps = {
    fetchPartnerDiscountsIfNeeded,
    forceFetchDiscounts,
    fetcheBonsByPartnerId,
    fetcheFAQByPartnerId,
    resetLock,
    resetOrder
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(MerchantCardPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/MerchantCardPage.js